<template>
    <div class="bms">

        <div class="paiOpenCardBMS">
            <div class="fotoOpenCardBms">
                <div class="efeitoFrontendBMS"></div>
                <div class="efeitoFrontendBMS2">
                    <HionEffect class="HionEffectBmsOpenCard" :configHionEffect="configHionEffectBmsOpenCard" Raio="true" />
                    <LinhaHorizontalY class="LinhaBmsOpenCard" :configLinhasY="configLinhasBmsOpenCardY" />
                </div>
                <mq-layout :mq="['xs', 'sm']">
                    <img
                        src="../../assets/bmsOPENCARD_SMALL.jpg"
                        alt="Hion Tecnologia"
                        class="OpenCardBms"
                    />
                </mq-layout>
                 <mq-layout mq="md+">
                    <img
                        src="../../assets/bmsOPENCARD.jpg"
                        alt="Hion Tecnologia"
                        class="OpenCardBms"
                    />
                </mq-layout>
                <div class="tituloOpenCardBms">BMS HION</div>
                <div class="subtituloOpenCardBms">Sistema Gerenciador de Baterias</div>
            </div>
        </div> <!-- final DIV paiOpenCardBMS -->

        <div class="ConteudoBMS">

            <div class="backgroundBMS">
                <div class="efeitoLogoPortifolioSolucoesTecnologia1">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia1" :configHionEffect="configHionEffectBms" />
                </div>
                <div class="efeitoLogoPortifolioSolucoesTecnologia2">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia2" :configHionEffect="configHionEffectBms" />
                </div>
                <div class="efeitoLogoContatoHome1">
                    <HionEffect class="HionEffectHomeContato1" :configHionEffect="configHionEffectBms" />
                </div>
                <div class="efeitoLogoContatoHome2">                 
                    <HionEffect class="HionEffectHomeContato2" :configHionEffect="configHionEffectBms" />
                </div>
                <div class="efeitoLogoBMS1">
                    <HionEffect class="HionEffectBMS1" :configHionEffect="configHionEffectBms" />
                </div>
                <div class="efeitoLogoBMS2">
                    <HionEffect class="HionEffectBMS2" :configHionEffect="configHionEffectBms" Raio="true" />
                </div>

                <div class="efeitoLinhaLithiumSolucoesTecnologia1">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia2">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia3">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia4">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia5">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia6">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia7">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia8">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia9">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia10">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia11">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia12">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia13">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia7">
                    <LinhaHorizontal :configLinhas="configLinhasBms" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia8">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia9">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia10">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia11">
                    <LinhaHorizontalY :configLinhasY="configLinhasBmsY" />
                </div>

                <div class="efeitoAneisPortifolioSolucoesTecnologia1">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia2">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia3">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia4">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia5">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia6">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia7">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia8">
                    <AneisEffect :configAneis="configAneisBms" />
                </div>

                 <div class="efeitoArgolasPortifolioSolucoesTecnologia1">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia2">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia3">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia4">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia5">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia6">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia7">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia8">
                    <ArgolasEffect :configArgolas="configArgolasBms"/>
                </div>

                <div class="linhaSombraBMS"></div>
            </div> <!-- final DIV ConteudoBMS -->
            
            <div class="frontendBMS">
                <!-- Local destinado ao efeitos de linhas argolas , etc dentro do frontendBMS -->
                <LinhaHorizontal class="LinhaBmsFrontend1" :configLinhas="configLinhasBmsFrontend" />
                <ArgolasEffect class="ArgolasBmsFrontend1" :configArgolas="configArgolasBmsFrontend"/>
                <ArgolasEffect class="ArgolasBmsFrontend2" :configArgolas="configArgolasBmsFrontend"/>
                <AneisEffect class="AneisBmsFrontend1" :configAneis="configAneisBmsFrontend" />
                <AneisEffect class="AneisBmsFrontend2" :configAneis="configAneisBmsFrontend" />
                
                <mq-layout :mq="['xs', 'sm']">
                    <LinhaHorizontal class="LinhaBmsFrontend2" :configLinhas="configLinhasBmsFrontend" />
                    <LinhaHorizontal class="LinhaBmsFrontend3" :configLinhas="configLinhasBmsFrontend" />
                </mq-layout>

                <div class="tituloFrontendBMS text-center">
                    Produzimos o Sistema de Gerenciamento de Baterias
                    mais Flexível do Mundo
                </div>
                <div class="textoFrontendBMS">
                    O <strong>BMS HION</strong> é um <strong>sofisticado</strong> e 
                    <strong>poderoso Sistema Elêtrônico de Gerenciamento de Baterias</strong>
                    capaz de manter <strong>qualquer tipo de bateria</strong> operando de forma 
                    <strong>eficiente</strong> e <strong>segura</strong> nas mais variadas condições,
                    e em qualquer tipo de aplicação. O <strong>BMS HION</strong> maximiza o desempenho, 
                    a segurança e a longevidade das baterias, além de proteger de forma vitalícia as 
                    células e o pack das baterias através de nosso <strong>moderno</strong> e <strong>exclusivo</strong> 
                    algoritmo de monitoramento que representa um <strong>compromisso</strong> entre robustez, precisão, 
                    adaptabilidade e aplicabilidade. O <strong>BMS HION</strong> permite a total <strong>gestão</strong>, 
                    <strong>conectividade</strong> e <strong>interação</strong> com todas as suas baterias em <strong>tempo real</strong>.
                </div>
                <div class="iconesBIGBms1">
                    <b-container class="containerIconesBIGBms">
                        <b-row>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms1.jpg"
                                    alt="BMS HION - Proteção"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">PROTEÇÂO</div>
                            </b-col>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms2.jpg"
                                    alt="BMS HION - Segurança"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">SEGURANÇA</div>
                            </b-col>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms3.jpg"
                                    alt="BMS HION - Inteligênia"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">INTELIGÊNCIA</div>
                            </b-col>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms4.jpg"
                                    alt="BMS HION - Conectividade"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">CONECTIVIDADE</div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

                <div class="textoFrontendBMS">
                    O <strong>BMS HION</strong> realiza o monitoramento e a gestão completa de todos os parâmetros
                    de todas as suas baterias. O <strong>BMS HION</strong> monitora constantemente
                    a <strong>tensão total</strong> da bateria e
                    a <strong>tensão individual</strong> de todas as células presentes na bateria com<strong> alta precisão</strong>.
                     Monitora também a <strong>corrente total</strong> da bateria, além de proteger
                    ativamente contra sobrecargas e curto-circuitos. O <strong>BMS HION</strong> monitora e protege 
                    a bateria contra todas as flutuações de <strong>temperatura</strong> maximizando a entrega de energia 
                    e protegendo-as contra incêndios e explosões.
                </div>

                <div class="iconesBIGBms1">
                    <b-container class="containerIconesBIGBms">
                        <b-row>
                            <b-col cols="12" md="4" class="text-center">
                                <img
                                    src="../../assets/icon_bms5.jpg"
                                    alt="BMS HION - MONITOR TENSÃO"
                                    class="thumbBms2"
                                >
                                <div class="legendaIconesBIGBms text-center">TENSÃO</div>
                            </b-col>
                            <b-col cols="12" md="4" class="text-center">
                                <img
                                    src="../../assets/icon_bms6.jpg"
                                    alt="BMS HION - MONITOR CORRENTE"
                                    class="thumbBms2"
                                >
                                <div class="legendaIconesBIGBms text-center">CORRENTE</div>
                            </b-col>
                            <b-col cols="12" md="4" class="text-center">
                                <img
                                    src="../../assets/icon_bms7.jpg"
                                    alt="BMS HION - TEMPERATURA CÉLULAS"
                                    class="thumbBms2"
                                >
                                <div class="legendaIconesBIGBms text-center">TEMPERATURA</div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

                <div class="textoFrontendBMS">
                    Através de nosso <strong>moderno</strong> e <strong>exclusivo</strong> 
                    algoritmo de monitoramento, o <strong>BMS HION</strong> é capaz de determinar
                     o <strong> estado da carga</strong> das células, 
                    o <strong>estado de saúde</strong> e a <strong>vida útil</strong> 
                    restante da bateria  com  <strong> alta precisão</strong>. 
                    O <strong>BMS HION protege ativamente</strong> e realiza o <strong> gerenciamento térmico</strong> 
                    de todas as células. Além de controlar completamente a carga e a descarga da bateria,
                    realizar o <strong>diagnóstico de falhas</strong> em <strong>tempo real</strong> e se comunicar 
                    com outros módulos ou baterias através dos principais protocolos de comunicação existentes.
                </div>

                <div class="iconesBIGBms1">
                    <b-container class="containerIconesBIGBms">
                        <b-row>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms8.jpg"
                                    alt="BMS HION - ESTADO DA CARGA"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">ESTADO DA CARGA</div>
                            </b-col>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms9.jpg"
                                    alt="BMS HION - ESTADO DA SAÚDE"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">ESTADO DA SAÚDE</div>
                            </b-col>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms10.jpg"
                                    alt="BMS HION - VIDA ÚTIL RESTANTE"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">VIDA ÚTIL RESTANTE</div>
                            </b-col>
                            <b-col cols="12" md="6" lg="3" class="text-center">
                                <img
                                    src="../../assets/icon_bms11.jpg"
                                    alt="BMS HION - DIAGNÓSTICO DE FALHAS"
                                    class="thumbBms1"
                                >
                                <div class="legendaIconesBIGBms text-center">DIAGNÓSTICO DE FALHAS</div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

                <div class="textoFrontendBMS">
                    Todas as Baterias são integradas por várias células 
                    do mesmo tipo e especificação. Teoricamente elas deveriam ser idênticas, porém 
                    <strong>é inevitável</strong> que não exista <strong>diferenças entre</strong> 
                    cada uma das <strong>células</strong> dentro da bateria.
                    Tornando-se um problema sério em qualquer tipo de bateria. 
                    E com o aumento do tempo de operação da bateria, 
                    a uniformidade das células irá piorar, <strong>reduzindo</strong> significativamente a 
                    <strong>capacidade nominal</strong> e a <strong>vida útil</strong> restante da bateria. 
                    O <strong>BMS HION</strong> vem de fábrica integrado com um <strong>poderoso</strong> sistema de 
                    <strong> balanceamento ativo</strong> capaz de realizar transferências entre as cargas das células 
                    quando o estado da carga de uma célula começar a se diferenciar das demais. O <strong> balanceamento ativo</strong>
                    do <strong>BMS HION</strong> é necessário para manter a energia das <strong>células equilibradas</strong>, 
                    <strong>estender</strong> a <strong>vida útil</strong> da bateria e alcançar o <strong>máximo desempenho</strong>
                    da bateria compensando qualquer não uniformidade na capacidade nominal e operacional das células.
                </div>

                <div class="paiBalanceamentoBMS">
                    <div class="subTituloFrontendBMS">
                        Sem BMS HION
                    </div>
                    <div class="subTextoFrontendBMS">
                        desequilíbrio, redução da capacidade e vida útil
                    </div>
                    <div class="fotoPictureBMS1">
                        <img
                            src="../../assets/picture_bms1.jpg"
                            alt="BMS HION - SEM BALANCEAMENTO"
                            class="PictureBMS"
                        />
                    </div>
                    <div class="subTituloFrontendBMS">
                        Com BMS HION
                    </div>
                    <div class="subTextoFrontendBMS">
                        células equilibradas e máximo desempenho
                    </div>
                    <div class="fotoPictureBMS1">
                        <img
                            src="../../assets/picture_bms2.jpg"
                            alt="BMS HION - BALANCEAMENTO ATIVO"
                            class="PictureBMS"
                        />
                    </div>
                </div>

                <div class="textoFrontendBMS">
                    O <strong>BMS HION</strong> é uma solução BMS totalmente modular, permitindo 
                    a aplicação em qualquer tipo de bateria com a energia e a capacidade nominal que desejar.
                    A <strong> eficiência energética</strong> e a <strong>proteção</strong> do <strong>BMS HION é incomparável </strong>, 
                    tornando-o perfeito para qualquer tipo de aplicação.
                    Configure o dimensionamento de sua bateria através da <strong>Plataforma Interativa HION</strong>
                    e comece agora mesmo sua operação com <strong>monitoramento</strong> e <strong>proteção</strong> 
                    em <strong>tempo real</strong>. Com o <strong>BMS HION</strong>
                    todos os parâmetros operacionais podem ser configurados de acordo com as características
                    de sua bateria, incluindo a potência, tensão, corrente, temperatura, nível de profundidade de descarga, 
                    sistema de pré-carga e muito mais.
                </div>

                <div class="paiFeaturesBMS">
                    <div class="maeTituloFeatures">
                        <i class="fas fa-charging-station iconeTituloFeaturesBMS"></i>
                        <div class="tituloFeaturesBMS">FUNCIONALIDADES <strong>BÁSICAS</strong></div>
                    </div>
                    <div class="maeContainerFeaturesBMS">
                        <b-container class="containerFeaturesBMS">
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-meteor iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Flexível e modular</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-car-battery iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Monitor integral da tensão</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-tachometer-alt iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Monitor integral da corrente</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-thermometer-half iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Monitor integral da temperatura</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-bolt iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Proteção contra sobrecarga</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-bomb iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Proteção contra curto-circuito</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-temperature-high iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Proteção contra sobretemperatura</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-fan iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Gerenciamento térmico ativo</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-percent iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Monitor estado da carga</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-heartbeat iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Monitor estado da saúde</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-balance-scale iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Balanceamento inteligente</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-sync-alt iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Programável</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-broadcast-tower iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Conexão Internet</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fab fa-bluetooth iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Bluetooth BLE</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-chart-pie iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Plataforma Interativa HION</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-stethoscope iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Diagnóstico Ativo de Falhas</div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

                <div class="paiFotoFullBMS">
                    <mq-layout :mq="['xs', 'sm']">
                        <img
                            src="../../assets/bms_conectado_SMALL.jpg"
                            alt="BMS HION - TOTALMENTE CONECTADA"
                            class="FotoFullBMS"
                            id="plataformaInterativa"
                        >
                        <div class="efeitoFotoFullBMS"></div>
                    </mq-layout>
                    <mq-layout mq="md+">
                        <img
                            src="../../assets/bms_conectado.jpg"
                            alt="BMS HION - TOTALMENTE CONECTADA"
                            class="FotoFullBMS"
                            id="plataformaInterativa"
                        />
                    </mq-layout>
                </div>

                <div class="paiWifiFeaturesBMS">
                    <div class="maeTituloWifiFeatures">
                        <i class="fas fa-wifi iconeTituloWifiFeaturesBMS"></i>
                        <div class="tituloWifiFeaturesBMS">FUNCIONALIDADES <strong>WI-FI</strong></div>
                        <mq-layout mq="md+">
                            <HionEffect class="HionEffectBmsWifiFeatures" :configHionEffect="configHionEffectBmsOpenCard" Raio="true" />
                        </mq-layout>
                    </div>
                    <div class="maeContainerWifiFeaturesBMS">
                        <b-container class="containerWifiFeaturesBMS">
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                <i class="fas fa-key iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Login (usuário e senha)</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-upload iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Atualização Remota</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-cloud-upload-alt iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Base de dados na nuvem</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-sms iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">SMS com alarmes críticos</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-power-off iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Controle remoto ON e OFF</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-history iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Tempo de amostragem configurável</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-sd-card iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Armazenamento SD CARD</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-chart-line iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Dashboard Interativo</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-satellite-dish iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Conexão de dados 3G</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-map-marker-alt iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">GPS</div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

                <div class="paiFotoFullBMS">
                    <mq-layout :mq="['xs', 'sm']">
                        <img
                            src="../../assets/plataformaInterativa_SMALL.jpg"
                            alt="BMS HION - PLATAFORMA INTERATIVA HION"
                            class="FotoFullBMS"
                            id="plataformaInterativa"
                        />
                    </mq-layout>
                    <mq-layout mq="md+">
                        <img
                            src="../../assets/plataformaInterativa.jpg"
                            alt="BMS HION - PLATAFORMA INTERATIVA HION"
                            class="FotoFullBMS"
                            id="plataformaInterativa"
                        />
                    </mq-layout>
                </div>

                <div class="paiWifiFeaturesBMS">
                    <div class="maeTituloWifiFeatures">
                        <i class="fas fa-thumbs-up iconeTituloWifiFeaturesBMS"></i>
                        <div class="tituloWifiFeaturesBMS" id="OpcionaisFeatures">FUNCIONALIDADES <strong>OPCIONAIS</strong></div>
                        <mq-layout mq="md+">
                            <HionEffect class="HionEffectBmsWifiFeatures" :configHionEffect="configHionEffectBmsOpenCard" Raio="true" />
                        </mq-layout>
                    </div>
                    <div class="maeContainerWifiFeaturesBMS">
                        <b-container class="containerWifiFeaturesBMS">
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                <i class="fas fa-tv iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">LCD Touch Screen</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-signal iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Display Bargraph Led</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-car iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface CAN isolada</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fab fa-usb iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface USB isolada</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-project-diagram iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface SPI isolada</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-microchip iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface RS-232/RS-485 MODBUS</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-compress-arrows-alt iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Sensor Pressão</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-car-crash iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Sensor de Colisão</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-smoking iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Sensor de Fumaça</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-cloud-rain iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Sensor de Umidade</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-broadcast-tower iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface LPWA</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-satellite-dish iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface Sigfox</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-draw-polygon iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface LoRa</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-mobile-alt iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Interface 4G ou 5G</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-balance-scale iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Balanceamento Ativo Alta Potência</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-database iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Ethernet e Servidor Offline</div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>

                <div class="paiFeaturesBMS">
                    <div class="maeTituloFeatures">
                        <i class="fas fa-cogs iconeTituloFeaturesBMS"></i>
                        <div class="tituloFeaturesBMS">ESPECIFICAÇÕES <strong>TÉCNICAS</strong></div>
                    </div>
                    <div class="maeContainerFeaturesBMS">
                        <b-container class="containerFeaturesBMS">
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-bed iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Baixo Consumo SLEEP</div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerWifiFeaturesBMS">
                                    <i class="fas fa-magnet iconeContainerWifiFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerWifiFeaturesBMS">
                                    <div class="legendaIconesWifiFeaturesBMS text-left">Alta Imunidade EMI</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2" md="1" lg="2" class="text-right colcontainerFeaturesBMS">
                                <i class="fas fa-random iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="4" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Contator HVDC </div>
                                </b-col>
                                <b-col cols="2" md="1" lg="1" class="text-right colcontainerFeaturesBMS">
                                    <i class="fas fa-check iconeContainerFeaturesBMS"></i>
                                </b-col>
                                <b-col cols="10" md="5" lg="5" class="text-left colcontainerFeaturesBMS">
                                    <div class="legendaIconesFeaturesBMS text-left">Sistema Pré-carga</div>
                                </b-col>
                            </b-row>
                        </b-container>

                        <div class="tableEspecificacoesBMS">
                            <b-table striped hover :items="especificacoes"></b-table>
                        </div>

                    </div>
                </div>

                <div class="contatoBms">
                    <div class="backgroundContatoBms">
                            <div class="efeitoLogoContatoBms1">
                                <HionEffect class="HionEffectBmsContato1" :configHionEffect="configHionEffectBmsContato" />
                            </div>
                            <div class="efeitoLogoContatoBms2">                 
                                <HionEffect class="HionEffectBmsContato2" :configHionEffect="configHionEffectBmsContato" />
                            </div>
                            <LinhaHorizontalY :configLinhasY="configLinhasContatoBmsY" class="efeitoLinhaContatoBms2" />
                            <LinhaHorizontal :configLinhas="configLinhasContatoBms" class="efeitoLinhaContatoBms" />
                            <ArgolasEffect class="ArgolasEfeitoLinhaContatoBms" :configArgolas="configArgolasBmsContato"/>
                    </div>
                    <div class="frontendContatotBms">
                        <div class="tituloContatoBms">Deseja utilizar o BMS HION em seu projeto?<br>Fale com a gente!</div>
                        <div class="formContatoBms">
                            <b-form @submit="SubmitFormBMS">
                                <b-form-group id="FormGrupoEmail-Bms">
                                    <b-form-input
                                    id="input-Email-Contato-Bms"
                                    v-model="formBMS.email"
                                    type="email"
                                    required
                                    placeholder="seuemail@gmail.com"
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group id="FormGrupoMensagem-Bms">
                                    <b-form-input
                                    id="input-Mensagem-Contato-Bms"
                                    v-model="formBMS.mensagem"
                                    required
                                    placeholder="Mensagem"
                                    ></b-form-input>
                                </b-form-group>

                                <b-button type="submit" class="botaoFormContatoBms">Enviar</b-button>
                            </b-form>
                        </div>
                    </div>
                </div>

            </div> <!-- final DIV FrontendBMS -->

        </div> <!-- final DIV ConteudoBMS -->
    </div> <!-- final DIV bms -->
</template>

<script>
import HionEffect from '../efeitos/hion_globo'
import LinhaHorizontal from '../efeitos/LinhaHorizontal'
import LinhaHorizontalY from '../efeitos/LinhaHorizontalY'
import ArgolasEffect from '../efeitos/Argolas'
import AneisEffect from '../efeitos/Aneis'

export default {
    name: 'Bms',
    components: { HionEffect, LinhaHorizontal, ArgolasEffect, AneisEffect, LinhaHorizontalY },
    data() {
        return {
            configHionEffectBms: {
                backgroundHionEffect: "#2e2d2c",
                CorHionEffect:"#008fac",
            },
            configHionEffectBmsOpenCard: {
                backgroundHionEffect: "#eee",
                CorHionEffect:"#008fac",
                CorRaio:"#ffd618"
            },
            configLinhasBms: {
                backgroundLinhas: "#2e2d2c",
                CorLinhas: "#008fac"
            },
            configLinhasBmsY: {
                backgroundLinhasY: "#2e2d2c",
                CorLinhasY: "#008fac"
            },
            configLinhasBmsOpenCardY: {
                backgroundLinhasY: "#eee",
                CorLinhasY: "#008fac"
            },
            configLinhasBmsFrontend: {
                backgroundLinhas: "#eee",
                CorLinhas: "#008fac"
            },
            configAneisBms: {
                backgroundAneis: "#2e2d2c",
                CorAneis: "#008fac",
            },
            configAneisBmsFrontend: {
                backgroundAneis: "#eeee",
                CorAneis: "#008fac",
            },
            configArgolasBms: {
                backgroundArgolas: "#2e2d2c",
                CorArgola: "#008fac",
            },
            configArgolasBmsFrontend: {
                backgroundArgolas: "#eee",
                CorArgola: "#008fac",
            },
            especificacoes: [
                { especificações_elétricas: 'Tensão Nominal de Operação', mínimo: '9', nominal: '24', máximo: '60', unidade: 'V'},
                { especificações_elétricas: 'Consumo de Corrente Ativo', mínimo: '20', nominal: '30', máximo: '60', unidade: 'mA' },
                { especificações_elétricas: 'Consumo de Corrente Sleep', mínimo: '300', nominal: '1000', máximo: '7000', unidade: 'uV' },
                { especificações_elétricas: 'Capacidade Corrente Isolada', mínimo: '5', nominal: '50', máximo: '2000', unidade: 'A' },
                { especificações_elétricas: 'Faixa Temperatura de Operação', mínimo: '-40', nominal: '25', máximo: '85', unidade: 'ºC' },
                { especificações_elétricas: 'Tensão Individual de Células', mínimo: '1', nominal: '3.2', máximo: '5', unidade: 'V' },
                { especificações_elétricas: 'Número de Células em Série', mínimo: '6', nominal: '8', máximo: '16', unidade: '*' },
                { especificações_elétricas: 'Quantidade BMS HION Empilhável', mínimo: '0', nominal: '1', máximo: '16', unidade: '*' },
                { especificações_elétricas: 'Tensão Máxima BMS HION Empilhável', mínimo: '24', nominal: '76', máximo: '960', unidade: 'V' },
                { especificações_elétricas: 'Período de Amostragem dos Sinais', mínimo: '4.13', nominal: '12.6', máximo: '1000000', unidade: 'uS' },
                { especificações_elétricas: 'Número de termistores por BMS', mínimo: '8', nominal: '8', máximo: '16', unidade: '*' },
                { especificações_elétricas: 'Resolução da Temperatura', mínimo: '0.5', nominal: '0.5', máximo: '1', unidade: 'ºC' },
                { especificações_elétricas: 'Resistor Pré-Carga', mínimo: '250', nominal: '1000', máximo: '10000', unidade: 'Ohm' },
                { especificações_elétricas: 'Tensão Contator e Atuador', mínimo: '9', nominal: '12', máximo: '13', unidade: 'V' },
                { especificações_elétricas: 'Corrente Contator e Atuadores', mínimo: '15', nominal: '60', máximo: '1000', unidade: 'mA' },
                { especificações_elétricas: 'Tensão Isolamento', mínimo: '', nominal: '2.5', máximo: '', unidade: 'kV' },
            ],
            configHionEffectBmsContato: {
                backgroundHionEffect: "#008fac",
                CorHionEffect:"#fff",
            },
            configLinhasContatoBms: {
                backgroundLinhas: "#008fac",
                CorLinhas: "#fff"
            },
            configLinhasContatoBmsY: {
                backgroundLinhasY: "#008fac",
                CorLinhasY: "#fff"
            },
            configArgolasBmsContato: {
                backgroundArgolas: "#008fac",
                CorArgola: "#fff",
            },
            formBMS: {
                email: '',
                mensagem: ''
            },
        }
    },
    methods: {
        SubmitFormBMS(evt) {
            evt.preventDefault()
            alert(JSON.stringify(this.formBMS))
        },
    }
}
</script>

<style>
.bms {
    position: relative;
    background:#eee;
    color:white;
    height: 100%;
    width: 100%;
    min-height: 500px;
}

/* inicio do CSS de OPEN CARD BMS  *************************************************************/
.paiOpenCardBMS {
    position: relative;
    max-height: 480px;
    width: 100%;
    overflow: hidden;
}
.fotoOpenCardBms {
    height:100%;
    width: 100%;
    text-align: center;
    overflow: hidden;
}
.OpenCardBms {
    width: 100%;
}
.efeitoFrontendBMS {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: rgb(0, 0, 0);
    background: rgba(0, 0, 0, 0.5); /* Black see-through */
    animation: fadein 2s;
}
.efeitoFrontendBMS2 {
    position: absolute;
    width: 75%;
    height: 100px;
    background: #eee;
    box-shadow: 5px 5px 5px #000, -5px -5px 5px #000;
    top:calc(100% - 100px);
    left: 12.5%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
.HionEffectBmsOpenCard {
    position: absolute;
    top: 5px;
    left: calc(100% - 130px);
    width: 90px;
    height: 90px;
}
.LinhaBmsOpenCard {
    position: absolute;
    top:10px;
    left: 10px;
    width: 240px;
    height: 55px;
}
.tituloOpenCardBms {
    color: #ffd618;
    font-size: 5em;
    font-family: 'Play';
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-80%, -75%);
    -ms-transform: translate(-80%, -75%);
    transform: translate(-80%, -75%);
    text-align: left;
    text-shadow: 1px 1px 20px #000,  0px 0px 20px #000,  0px 0px 20px #000,  0px 0px 20px #000;
    animation: fadein 4s;
}
@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
.subtituloOpenCardBms {
    color: #eee;
    font-size: 1.5em;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-75%, -30%);
    -ms-transform: translate(-75%, -30%);
    transform: translate(-75%, -30%);
    text-align: left;
    text-shadow: 1px 1px 20px #000,  0px 0px 20px #000,  0px 0px 20px #000,  0px 0px 20px #000;
    animation: fadein 6s;
}

/* inicio do CSS de ConteudoBMS  *************************************************************/
.ConteudoBMS {
    position: relative;
    height: 8050px;
    width: 100%;
    background: #2e2d2c;
    overflow: hidden;
}
/*BACKGROUND BMS*******************************/
.backgroundBMS {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3;
}
.linhaSombraBMS {
    position: absolute;
    height: 1px;
    width: 100%;
    z-index: 3;
    top: 0px;
    left: 0px;
    background: #000;
    box-shadow: 1px 1px 5px #000,  2px 2px 5px #000,  2px 2px 5px #000,  2px 2px 5px #000,
                1px 1px 2px #000,  2px 2px 2px #000,  2px 2px 2px #000,  2px 2px 2px #000,
                1px 1px 2px #000,  2px 2px 2px #000,  2px 2px 2px #000,  2px 2px 2px #000;
}

.efeitoLogoBMS1 {
    position: absolute;
    top: calc(100% - 670px);
    left: calc(100% - 550px);
    height: 500px;
    width: 500px;
    overflow: hidden;
}
.HionEffectBMS1 {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0.6;
    transform: rotate(43deg);
}
.efeitoLogoBMS2 {
    position: absolute;
    top:calc(100% - 660px);
    left: calc(100% - 530px);
    height: 500px;
    width: 500px;
    overflow: hidden;
}
.HionEffectBMS2 {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0.15;
    transform: rotate(22deg);
}
/*FRONTEND************************************/
.frontendBMS {
    position: relative;
    height: 95%;
    width: 75%;
    z-index: 4;
    background: #eee;
    margin: auto;
    box-shadow: 5px 5px 5px #000, -5px 5px 5px #000;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
.LinhaBmsFrontend1 {
    position: absolute;
    top: 90px;
    left: calc(100% - 155px);
    transform: rotate(270deg);
    width: 240px;
    height: 55px;
}
.LinhaBmsFrontend2 {
    position: absolute;
    top: 1300px;
    left: -85px;
    transform: rotate(270deg);
    width: 240px;
    height: 55px;
}
.LinhaBmsFrontend3 {
    position: absolute;
    top: 3000px;
    left: calc(100% - 155px);
    transform: rotate(270deg);
    width: 240px;
    height: 55px;
}
.ArgolasBmsFrontend1 {
    position: absolute;
    top:350px;
    left: 15px;
    width: 30px;
    height: 60px;
}
.ArgolasBmsFrontend2 {
    position: absolute;
    top:1950px;
    left: calc(100% - 50px);
    width: 30px;
    height: 60px;
}
.AneisBmsFrontend1 {
    position: absolute;
    top:850px;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.AneisBmsFrontend2 {
    position: absolute;
    top:1200px;
    left: 30px;
    width: 33.33px;
    height: 100px;
}
.tituloFrontendBMS {
    display: inline-block;
    width:100%;
    margin:auto;
    padding: 0px 100px 50px 100px;
    font-size: 2.5em;
    font-weight: bold;
    line-height: 1;
    /* color: #008fac; */
    color: #008fac;
    font-family: 'Play';
}
.textoFrontendBMS {
    display: inline-block;
    width:100%;
    margin:auto;
    padding: 0px 100px 10px 100px;
    font-size: 1.2em;
    text-align: center;
    /* color: #008fac; */
    color: #2e2d2c;
    font-family: 'Play';
}
.iconesBIGBms1 {
    width: 100%;
    overflow:hidden;
    padding: 50px 0px 50px 0px;
}
.containerIconesBIGBms {
    width: 100%;
}
.thumbBms1 {
    width: 150px;
    height: 150px;
}
.thumbBms2 {
    width: 150px;
    height: 150px;
}
.legendaIconesBIGBms {
    text-align: center;
     color: #008fac;
    /*color: #2e2d2c;*/
    font-size: 1.3em;
    font-family: 'Play';
    font-weight: bold;
    padding-bottom: 30px;
}

.paiBalanceamentoBMS {
    position: relative;
    width: 100%;
}
.subTituloFrontendBMS{
    display: inline-block;
    width:100%;
    margin:auto;
    padding: 50px 100px 10px 100px;
    font-size: 2em;
    font-weight: bold;
    line-height: 1;
    color: #008fac;
    font-family: 'Roboto';
}
.subTextoFrontendBMS {
    display: inline-block;
    width:100%;
    margin:auto;
    padding: 0px 100px 50px 100px;
    font-size: 1.5em;
    line-height: 1;
    color: #2e2d2c;
    font-family: 'Roboto';
}
.fotoPictureBMS1 {
    width: 100%;
    padding: 0px 150px 50px 150px;
}
.PictureBMS {
    width: 100%;
}

.paiFotoFullBMS {
    position: relative;
    width: 100%;
    padding: 50px 0px 50px 0px;
}
.FotoFullBMS {
    width: 100%;
    /*outline: 1px solid white;*/
    /*outline-offset: -4px;*/
    box-shadow: 5px 5px 5px #000, -5px 5px 5px #000,
                5px -5px 5px #000, -5px -5px 5px #000;
}
#plataformaInterativa {
    box-shadow: none;
}
.efeitoFotoFullBMS {
    position: absolute;
    left:50%;
    top: calc(100% - 80px);
    background:#eee;
    width: 200px;
    height: 80px;
    border-radius: 40px;
    z-index: 4;
}

/* TITULO FUNCIONALIDADES WI-FI */
.paiWifiFeaturesBMS {
    position: relative;
    width: 100%;
    padding: 10px 0px 50px 0px;
}
.maeTituloWifiFeatures {
    width: 100%;
}
.iconeTituloWifiFeaturesBMS {
    position: absolute;
    font-size: 4em;
    color:#000;
    left: 50px;
}
.tituloWifiFeaturesBMS {
    position: absolute;
    font-size: 2.5em;
    color:#2e2d2c;
    left: 150px;    
}
.HionEffectBmsWifiFeatures {
    width: 80px;
    height: 80px;
    top: -15px;
    left: calc(100% - 120px);  
}

/* FUNCIONALIDADES BASICAS */
.paiFeaturesBMS {
    position: relative;
    width: 100%;
    padding: 50px 0px 0px 0px;
}
.maeContainerFeaturesBMS {
    width: 100%;
    padding: 120px 0px 10px 0px;
}
.containerFeaturesBMS {
    width: 100%;
}
.colcontainerFeaturesBMS {
    padding-bottom: 10px;
}
.iconeContainerFeaturesBMS {
    font-size: 2em;
    /*color:#ffd618;*/
    color: #008fac;
}
.legendaIconesFeaturesBMS {
    font-size: 1.2em;
    color:#2e2d2c;
    font-family: 'Raleway';
}

/* TITULO FUNCIONALIDADES BASICAS */
.paiWifiFeaturesBMS {
    position: relative;
    width: 100%;
    padding: 10px 0px 50px 0px;
}
.maeTituloFeatures {
    width: 100%;
}
.iconeTituloFeaturesBMS {
    position: absolute;
    font-size: 4em;
    color:#000;
    left: 50px;
}
.tituloFeaturesBMS {
    position: absolute;
    font-size: 3em;
    color:#2e2d2c;
    left: 150px;    
}

/* FUNCIONALIDADES WI-FI */
.maeContainerWifiFeaturesBMS {
    width: 100%;
    padding: 50px 0px 10px 0px;
}
.containerWifiFeaturesBMS {
    width: 100%;
}
.colcontainerWifiFeaturesBMS {
    padding-bottom: 10px;
}
.iconeContainerWifiFeaturesBMS {
    font-size: 2em;
    /*color:#ffd618;*/
    color: #008fac;
}
.legendaIconesWifiFeaturesBMS {
    font-size: 1.2em;
    color:#2e2d2c;
    font-family: 'Raleway';
}

.tableEspecificacoesBMS {
    padding: 50px 20px 50px 20px;
}

/* inicio do CSS de CARD CONTATO BMS *****/
.contatoBms{
    position: absolute;
    height: 400px;
    width: 100%;
    background: #008fac;
    overflow: hidden;
    top: calc(100% - 400px);
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
.backgroundContatoBms {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3;
}
.efeitoLogoContatoBms1 {
    position: absolute;
    top: calc(100% - 170px);
    left: calc(-30px - 200px);
    height: 400px;
    width: 400px;
    overflow: hidden;
}
.HionEffectBmsContato1 {
    position: relative;
    height: 100%;
    width: 100%;
    /*opacity: 0.6; */
    transform: rotate(43deg);
}
.efeitoLogoContatoBms2 {
    position: absolute;
    top:calc(100% - 195px);
    left: calc(-5px - 200px);
    height: 400px;
    width: 400px;
    overflow: hidden;
}
.HionEffectBmsContato2 {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0.2;
    transform: rotate(22deg);
}
.efeitoLinhaContatoBms {
    position: absolute;
    top: calc(100% - 70px);
    left: calc(100% - 250px);
    width: 240px;
    height: 55px;
    transform: scaleX(-1);
}
.efeitoLinhaContatoBms2 {
    position: absolute;
    top: 15px;
    left: 10px;
    width: 240px;
    height: 55px;
}
.ArgolasEfeitoLinhaContatoBms {
    position: absolute;
    top:15px;
    left: calc(100% - 40px);
    width: 30px;
    height: 60px;
}

.frontendContatotBms {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 4;
}
.tituloContatoBms {
    position: absolute;
    font-size: 2em;
    color: #fff;
    font-weight: bold;
    top:80px;
    left: 30px;
    max-width: 450px;
    line-height: 1.1;
}
.formContatoBms {
    position: absolute;
    top: 100px;
    left:calc(100% - 420px);
    width: 400px;
}
.botaoFormContatoBms {
    background: #fff;
    color: #008fac;
    font-family: 'Play';
    width: 80px;
    border: none;
    border-radius: 17px;
    float:right;
}
#input-Email-Contato-Bms {
    border: none;
    border-bottom: solid 2px #fff;
    background: #008fac;
}
#input-Email-Contato-Bms::placeholder {
    color: #eee;
}
#input-Mensagem-Contato-Bms {
    border: none;
    border-bottom: solid 2px #fff;
    background: #008fac;
}
#input-Mensagem-Contato-Bms::placeholder {
    color: #eee;
}


/* MEDIA QUERY LG ****************************************************************/
@media (min-width: 992px) and (max-width:1199px) { /* LG */

/* inicio do CSS de ConteudoBMS  *************************************************************/
.ConteudoBMS {
    height: 8520px;
}
.fotoPictureBMS1 {
    padding: 0px 100px 50px 100px;
}

/* Efeitos linhas frontend */
.AneisBmsFrontend2 {
    position: absolute;
    top:1500px;
    left: 10px;
    width: 33.33px;
    height: 100px;
}
.ArgolasBmsFrontend2 {
    top:2550px;
    left: calc(100% - 50px);
}



/* FUNCIONALIDADES BASICAS */
/* TITULO FUNCIONALIDADES BASICAS */
.iconeTituloFeaturesBMS {
    font-size: 3.5em;
    left: 30px;
}
.tituloFeaturesBMS {
    font-size: 2.5em;
    left: 120px;    
}

/* FUNCIONALIDADES WI-FI */
/* TITULO FUNCIONALIDADES WI-FI */
.iconeTituloWifiFeaturesBMS {
    font-size: 3.5em;
    left: 20px;
}
.tituloWifiFeaturesBMS {
    font-size: 2.2em;
    left: 100px;    
}

/* Correção para formulario de contato do BMS */
#IDformContatoBMS {
    width: 100vw;
    position:absolute;
    left: -17.5%;
    /*outline: none;
    outline-offset: none;*/
}

/* inicio do CSS de CARD CONTATO BMS *****/
.tituloContatoBms {
    font-size: 1.7em;
    top:90px;
    left: 15px;
    max-width: 380px;
}
.formContatoBms {
    top: 90px;
    left:calc(100% - 350px);
    width: 330px;
}

}


/* MEDIA QUERY MD *********************************************************/
@media (min-width: 768px) and (max-width:991px) { /* MD */

/* inicio do CSS de ConteudoBMS  *************************************************************/
.ConteudoBMS {
    height: 10200px;
}

/* Titulo OPEN CARD FRONTEND */
.tituloOpenCardBms {
    font-size: 4em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-90%, -75%);
    -ms-transform: translate(-90%, -75%);
    transform: translate(-90%, -75%);
}
.subtituloOpenCardBms {
    font-size: 1.2em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-85%, -30%);
    -ms-transform: translate(-85%, -30%);
    transform: translate(-85%, -30%);
}

/*BACKGROUND BMS*******************************/
.efeitoLogoBMS1 {
    top: calc(100% - 750px);
    left: calc(100% - 470px);
    height: 400px;
    width: 400px;
}
.efeitoLogoBMS2 {
    top:calc(100% - 720px);
    left: calc(100% - 450px);
    height: 400px;
    width: 400px;
}
/* Efeitos Linhas Frontend */
.AneisBmsFrontend1 {
    position: absolute;
    top:1200px;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.AneisBmsFrontend2 {
    position: absolute;
    top:2000px;
    left: 20px;
    width: 33.33px;
    height: 100px;
}
.ArgolasBmsFrontend2 {
    top:3000px;
    left: calc(100% - 50px);
}

/*FRONTEND BMS************************************/
.ArgolasBmsFrontend1 {
    top:700px;
    left: 15px;
}
.thumbBms1 {
    width: 150px;
    height: 150px;
}
.legendaIconesBIGBms {
    font-size: 1.4em;
}
.subTituloFrontendBMS{
    padding: 50px 50px 10px 50px;
    font-size: 1.7em;
}
.subTextoFrontendBMS {
    padding: 0px 50px 50px 50px;
    font-size: 1.3em;
}
.fotoPictureBMS1 {
    padding: 0px 40px 50px 40px;
}

.paiFotoFullBMS {
    width: 100%;
    padding: 50px 0px 50px 0px;
}
.FotoFullBMS {
    width: 100vw;
    position:absolute;
    left: -17.5%;
    /*outline: none;
    outline-offset: none;*/
}

/* FUNCIONALIDADES BASICAS ********************/
.iconeContainerFeaturesBMS {
    font-size: 1.5em;
}
.legendaIconesFeaturesBMS {
    font-size: 1em;
}
/* TITULO FUNCIONALIDADES BASICAS */
.iconeTituloFeaturesBMS {
    font-size: 3em;
    left: 30px;
}
.tituloFeaturesBMS {
    font-size: 2em;
    left: 100px;    
}

/* WIFI FEATUES **********************/
.paiWifiFeaturesBMS {
    padding: 530px 0px 50px 0px;
}
/* TITULO FUNCIONALIDADES WI-FI */
.iconeTituloWifiFeaturesBMS {
    font-size: 3em;
    left: 25px;
}
.tituloWifiFeaturesBMS {
    font-size: 2em;
    left: 100px;    
}
#OpcionaisFeatures {
    font-size: 1.7em;
    left: 80px;  
}
.HionEffectBmsWifiFeatures {
    width: 70px;
    height: 70px;
    top: -15px;
    left: calc(100% - 80px);  
}
/* FUNCIONALIDADES WI-FI */
.iconeContainerWifiFeaturesBMS {
    font-size: 1.5em;
}
.legendaIconesWifiFeaturesBMS {
    font-size: 1em;
}


/* inicio do CSS de CARD CONTATO BMS *****/
.contatoBms{
    height: 600px;
    width: 100%;
    top: calc(100% - 600px);
}
.tituloContatoBms {
    font-size: 2em;
    top:100px;
    left: 50px;
    max-width: 450px;
    line-height: 1.1;
}
.formContatoBms {
    top: 250px;
    left: 50px;
    width: 450px;
}
.botaoFormContatoBms {
    width: 100px;
    float:right;
}

}


/* MEDIA QUERY SM *************************************************************/
@media (min-width: 576px) and (max-width:767px) { /* SM */

/* inicio do CSS de ConteudoBMS  *************************************************************/

.ConteudoBMS {
    height: 13400px;
}
/* inicio do CSS de OPEN CARD BMS  *************************************************************/
.paiOpenCardBMS {
    max-height: 960px;
}
.HionEffectBmsOpenCard {
    top: 10px;
    left: calc(100% - 140px);
    width: 130px;
    height: 130px;
}
.efeitoFrontendBMS2 {
    width: 95%;
    height: 150px;
    top:calc(100% - 150px);
    left: 2.5%;
}
/*BACKGROUND**********************************/
.efeitoLogoBMS1 {
    top: calc(100% - 850px);
    left: calc(100% - 370px);
    height: 350px;
    width: 350px;
}
.efeitoLogoBMS2 {
    top:calc(100% - 820px);
    left: calc(100% - 350px);
    height: 350px;
    width: 350px;
}
/* Efeitos Linhas Frontend */
.AneisBmsFrontend1 {
    position: absolute;
    top:2000px;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.AneisBmsFrontend2 {
    position: absolute;
    top:2700px;
    left: 20px;
    width: 33.33px;
    height: 100px;
}
.ArgolasBmsFrontend2 {
    top:4000px;
    left: calc(100% - 50px);
}
/*FRONTEND************************************/
.frontendBMS {
    width: 95%;
    /*margin-top: 10px;*/
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
.tituloOpenCardBms {
    font-size: 5em;
    top: 50%;
    left:30%;
    -webkit-transform: translate(-30%, -120%);
    -ms-transform: translate(-30%, -120%);
    transform: translate(-30%, -120%);
}
.subtituloOpenCardBms {
    font-size: 1.5em;
    top: 50%;
    left: 30%;
    -webkit-transform: translate(-25%, -160%);
    -ms-transform: translate(-25%, -160%);
    transform: translate(-25%, -160%);
}
.ArgolasBmsFrontend1 {
    top:700px;
    left: 15px;
}
.tituloFrontendBMS {
    padding: 0px 80px 50px 80px;
    font-size: 2.5em;
}
.textoFrontendBMS {
    padding: 0px 80px 50px 80px;
    font-size: 1.2em;
}
.thumbBms1 {
    width: 180px;
    height: 180px;
}
.thumbBms2 {
    width: 180px;
    height: 180px;
}
.legendaIconesBIGBms {
    font-size: 1.5em;
}

.subTituloFrontendBMS{
    padding: 50px 20px 10px 20px;
    font-size: 1.7em;
}
.subTextoFrontendBMS {
    padding: 0px 20px 50px 20px;
    font-size: 1.3em;
}
.fotoPictureBMS1 {
    padding: 0px 10px 50px 10px;
}

/* FUNCIONALIDADES BASICAS *********************/
.maeContainerFeaturesBMS {
    padding: 100px 0px 10px 0px;
}
/* TITULO FUNCIONALIDADES BASICAS */
.iconeTituloFeaturesBMS {
    font-size: 3em;
    left: 30px;
}
.tituloFeaturesBMS {
    font-size: 2em;
    left: 110px;    
}

/* WIFI FEATUES ****************************/
/* FUNCIONALIDADES WI-FI */
.maeContainerWifiFeaturesBMS {
    padding: 100px 0px 10px 0px;
}
/* TITULO FUNCIONALIDADES WI-FI */
.iconeTituloWifiFeaturesBMS {
    font-size: 3em;
    left: 30px;
}
.tituloWifiFeaturesBMS {
    font-size: 2em;
    left: 110px;    
}

/* inicio do CSS de CARD CONTATO BMS *****/
.contatoBms{
    height: 600px;
    width: 100%;
    top: calc(100% - 600px);
}
.tituloContatoBms {
    font-size: 2em;
    top:100px;
    left: 50px;
    max-width: 450px;
    line-height: 1.1;
}
.formContatoBms {
    top: 250px;
    left: 50px;
    width: 450px;
}
.botaoFormContatoBms {
    width: 100px;
    float:right;
}

}


/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */

/* inicio do CSS de ConteudoBMS  *************************************************************/
.ConteudoBMS {
    height: 13900px;
}

/* inicio do CSS de OPEN CARD BMS  *************************************************************/
.paiOpenCardBMS {
    max-height: 960px;
}
.HionEffectBmsOpenCard {
    top: 10px;
    left: calc(100% - 140px);
    width: 130px;
    height: 130px;
}
.efeitoFrontendBMS2 {
    width: 95%;
    height: 150px;
    top:calc(100% - 150px);
    left: 2.5%;
}
/*BACKGROUND**********************************/
.efeitoLogoBMS1 {
    top: calc(100% - 850px);
    left: calc(100% - 370px);
    height: 350px;
    width: 350px;
}
.efeitoLogoBMS2 {
    top:calc(100% - 820px);
    left: calc(100% - 350px);
    height: 350px;
    width: 350px;
}
/* Efeitos Linhas Frontend */
.AneisBmsFrontend1 {
    position: absolute;
    top:4000px;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.AneisBmsFrontend2 {
    position: absolute;
    top:2700px;
    left: 20px;
    width: 33.33px;
    height: 100px;
}
.ArgolasBmsFrontend2 {
    top:3000px;
    left: calc(100% - 50px);
}
/*FRONTEND************************************/
.frontendBMS {
    width: 95%;
   /* margin-top: 10px; */
   border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
.tituloOpenCardBms {
    font-size: 5em;
    top: 50%;
    left:20%;
    -webkit-transform: translate(-15%, -165%);
    -ms-transform: translate(-15%, -165%);
    transform: translate(-15%, -125%);
}
.subtituloOpenCardBms {
    font-size: 1.5em;
    top: 50%;
    left: 20%;
    -webkit-transform: translate(-25%, -160%);
    -ms-transform: translate(-25%, -160%);
    transform: translate(-10%, -200%);
}
.LinhaBmsFrontend2 {
    top: 1600px;
}
.ArgolasBmsFrontend1 {
    top:1100px;
}
.tituloFrontendBMS {
    padding: 0px 70px 50px 70px;
    font-size: 2.5em;
}
.textoFrontendBMS {
    padding: 0px 40px 50px 40px;
    font-size: 1.3em;
}
.thumbBms1 {
    width: 180px;
    height: 180px;
}
.thumbBms2 {
    width: 180px;
    height: 180px;
}
.legendaIconesBIGBms {
    font-size: 1.5em;
}
.PictureBMS {
    padding: 0px;
}
.subTituloFrontendBMS{
    padding: 50px 0px 10px 0px;
    font-size: 1.8em;
    text-align: center;
}
.subTextoFrontendBMS {
    padding: 0px 0px 50px 0px;
    font-size: 1.3em;
    text-align: center;
}
.fotoPictureBMS1 {
    padding: 0px 0px 50px 0px;
}

/* FUNCIONALIDADES BASICAS */
.maeContainerFeaturesBMS {
    padding: 100px 0px 10px 0px;
}
/* TITULO FUNCIONALIDADES BASICAS */
.iconeTituloFeaturesBMS {
    font-size: 2.5em;
    left: 20px;
}
.tituloFeaturesBMS {
    font-size: 1.7em;
    left: 90px;    
}


/* WIFI FEATUES */
/* FUNCIONALIDADES WI-FI */
.maeContainerWifiFeaturesBMS {
    padding: 100px 0px 10px 0px;
}
/* TITULO FUNCIONALIDADES WI-FI */
.iconeTituloWifiFeaturesBMS {
    font-size: 2.5em;
    left: 20px;
}
.tituloWifiFeaturesBMS {
    font-size: 1.7em;
    left: 90px;    
}

/* inicio do CSS de CARD CONTATO BMS *****/
.contatoBms{
    height: 600px;
    width: 100%;
    top: calc(100% - 600px);
}
.tituloContatoBms {
    font-size: 2em;
    top:100px;
    left: 50px;
    max-width: 450px;
    line-height: 1.1;
}
.formContatoBms {
    top: 250px;
    left: 50px;
    width: 350px;
}
.botaoFormContatoBms {
    width: 100px;
    float:right;
}


}
</style>